
import { google } from 'google-maps';
import { Component, Watch, Vue } from 'vue-property-decorator';
import GoogleMapPolyLine from '@/components/Map/GoogleMapPolyLine.vue';
import GoogleMapPolygon from '@/components/Map/GoogleMapPolygon.vue';
import GoogleMapLoader from '@/components/Map/GoogleMapLoader.vue';
import { awsConfiguration } from '@/aws-configuration';
import { getModule } from 'vuex-module-decorators';
import MissionStore from '@/store/modules/missions';
import { RenderHelper } from '@/services/RenderHelper';
import { SinglePathMission } from '@/flightpath-components/models/SinglePathMission';
import { FieldOperationsModel } from '@/flightpath-components/models/FieldOperationsModel';
import { SimplePath } from '@/flightpath-components/models/SimplePath';
import GlobalStore from '@/store/modules/global';
import { GoogleMapConfig } from '@/flightpath-components/types/GoogleMapConfig';
@Component({
  components: {
    GoogleMapPolyLine,
    GoogleMapPolygon,
    GoogleMapLoader
  }
})
export default class MissionMap extends Vue {
  apiKey = awsConfiguration.apiKey;
  polyLines: Array<google.maps.PolylineOptions> = [];
  polygons: Array<google.maps.PolygonOptions> = [];
  missionStore = getModule(MissionStore, this.$store);
  globalStore = getModule(GlobalStore, this.$store);

  @Watch('missionStore.editedMission')
  onEditedMissionChange(mission: SinglePathMission) {
    this.renderMission(mission);
  }

  @Watch('missionStore.newMissionField')
  onFieldChange(field: FieldOperationsModel | null) {
    this.renderField(field);
  }

  @Watch('missionStore.newMissionPath')
  onPathChange(path: SimplePath) {
    this.renderPath(path);
  }

  get mapConfig(): GoogleMapConfig {
    return {
      locationControl: false,
      loaderOptions: { libraries: ['geometry'] },
      mapOptions: {
        zoom: 17,
        center: this.globalStore.defaultMapLocation,
        mapTypeId: 'hybrid',
        mapTypeControl: false,
        zoomControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        clickableIcons: false,
        disableDefaultUI: true
      }
    };
  }

  renderMission(mission: SinglePathMission | null) {
    this.polygons = [];
    this.polyLines = [];

    if (mission == null) return;

    this.polygons.push(RenderHelper.getFieldPolygonOptionsFromMission(mission));
    this.polygons.push(RenderHelper.getWorkAreaPolygonOptionsFromMission(mission));
    this.polygons.push(RenderHelper.getCropAreaPolygonOptionsFromMission(mission));
    this.polyLines.push(RenderHelper.getPathPolylineOptionsFromMission(mission));
  }

  renderField(field: FieldOperationsModel | null) {
    this.polygons = RenderHelper.clearFields(this.polygons);
    if (field == null) return;

    this.polygons.push(RenderHelper.getFieldPolygonOptionsFromPoint(field.BoundaryPoints));
  }

  renderPath(path: SimplePath | null) {
    this.polygons = RenderHelper.clearWorkAreas(this.polygons);
    this.polygons = RenderHelper.clearCropAreas(this.polygons);
    this.polyLines = RenderHelper.clearPaths(this.polyLines);

    if (path == null) return;

    this.polyLines.push(RenderHelper.getPathPolylineOptionsFromSimplePoint(path.Path));
    if (path.WorkAreas != undefined) this.polygons.push(RenderHelper.getWorkAreaPolygonOptionsFromSimplePoint(path.WorkAreas[0]));
  }
}
